import BaseFeature from '../../foundation/base/base';
import { initBehaviors, destroyBehaviors, resetBehaviorNames } from '../../foundation/featureLoader';

const classes = {
	open: 'o-modal--open',
	fullscreen: 'o-modal--fullscreen',
	noPadding: 'o-modal__wrapper--no-padding',
	fixed: 'o-modal--fixed'
};

export default class Modal extends BaseFeature {
	constructor(element) {
		super(element);

		this.body = window.features.dom.body;
		this.target = this.element.getAttribute('data-modal-id');
		this.initDomCache();
		this.addEventListeners();
		this.addSubscriptions();
	}

	addEventListeners() {
		this.addEventListener(this.dom.close, 'click.close', (e) => {
			e.preventDefault();
			this.publish('/modal/close');
		});

		this.addEventListener(this.dom.overlay, 'click.overlay', (e) => {
			e.preventDefault();
			this.publish('/modal/close');
		});
	}

	removeEventListeners() {
		this.removeEventListener(this.dom.close, 'click.close');
		this.removeEventListener(this.dom.overlay, 'click.overlay');
	}

	addSubscriptions() {
		this.subscribe('/modal/open', ({
			target, title = '', fullscreen, nopadding, closeBtn, fixed, onOpen
		} = {}) => {
			if (target && this.target && this.target !== target) {
				return;
			}
			this.setScreenMode(fullscreen);
			this.setPaddingMode(nopadding);
			this.updateCloseVisibility(closeBtn);
			this.updateContentFromId(target);
			this.updateFixedMode(fixed);
			this.open();

			if (onOpen) {
				onOpen(this);
			}

			this.updateTitle(title);
		});

		this.subscribe('/modal/close', () => {
			this.close();
		});
	}

	removeSubscriptions() {
		this.unsubscribe('/modal/open');
		this.unsubscribe('/modal/close');
	}

	addKeyListeners() {
		this.addEventListener(document, 'keyup', (e) => {
			if (e.keyCode === 27) {
				this.close();
			}
		});
	}

	removeKeyListeners() {
		this.removeEventListener(document, 'keyup');
	}

	/*
		Copies the entire content from an ID.
	*/
	updateContentFromId(target) {
		const element = document.getElementById(target);

		if (element) {
			this.dom.content.innerHTML = element.innerHTML;
		}
	}

	updateContentFromHtml(target) {
		this.dom.content.innerHTML = '';
		this.dom.content.appendChild(target);
	}

	setScreenMode(fullscreen) {
		this.element.classList.remove(classes.fullscreen);

		if (fullscreen) {
			this.element.classList.add(classes.fullscreen);
		}
	}

	setPaddingMode(nopadding) {
		this.dom.wrapper.classList.remove(classes.noPadding);

		if (nopadding) {
			this.dom.wrapper.classList.add(classes.noPadding);
		}
	}

	updateCloseVisibility(isVisible) {
		this.dom.close.classList.remove('u-hide');

		if (!isVisible) {
			this.dom.close.classList.add('u-hide');
		}
	}

	updateTitle(title) {
		this.dom.title.innerText = title;
	}

	open() {
		this.body.classList.add(classes.open);
		this.addKeyListeners();

		resetBehaviorNames({ context: this.dom.content });
		initBehaviors({ context: this.dom.content });
	}

	close() {
		this.body.classList.remove(classes.open);

		this.removeKeyListeners();
		destroyBehaviors({ context: this.dom.content });

		if (this.body.classList.contains(classes.fixed)) {
			this.body.classList.remove(classes.fixed);
		}
	}

	// Prevents background scrolling on fullscreen modals
	updateFixedMode(fixedMode) {
		this.body.classList.remove(classes.fixed);

		if (fixedMode) {
			this.body.classList.add(classes.fixed);
		}
	}

	cleanup() {
		this.removeEventListeners();
		this.removeSubscriptions();
		this.removeKeyListeners();
	}
}
